import {
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  InputLabel,
  LinearProgress,
  MenuItem,
  Paper,
  Typography,
} from "@material-ui/core";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { Select, TextField } from "formik-material-ui";
import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { useTestSequenceDefinitionsDispositions } from "../../../common/services/dispositionServices";
import {
  useGroupsByGroupType,
  useUnitTypeFamilies,
} from "../../projectManagementQueries";
import { useTestSequenceDefinition } from "../../testSequenceDefinitionQueries";
import { ErrorMessage } from "../../../common/ErrorMessage";
import {
  useAddProcedureDefinitionsToTestSequence,
  useAddReportDefinitionsToTestSequence,
  useRemoveProcedureDefinitionsFromTestSequence,
  useRemoveReportDefinitionsFromTestSequence,
  useUpdateReportSequence,
  useUpdateTestSequence,
} from "../../projectManagementMutations";
import { LSDBModal, useLSDBModalState } from "../../../common/LSDBModal";
import { WorkOrderTestSequenceTraveler } from "../customerDetails/workOrders/WorkOrderTestSequenceTraveler";
import ReceiptIcon from "@material-ui/icons/Receipt";
import LSDBColorPicker from "../../../common/LSDBColorPicker";
import RSDForm from "./RSDForm";
import ReportDefinitionsPicker from "./ReportDefinitions/ReportDefinitionsPicker";
import { ReportExecutionOrder } from "../../types/ReportExecutionOrder";
import { addProcedureDefinitionToList, removeProcedureDefinitionFromList } from "./ReportDefinitions/helpers";
import { useReportSequenceDefinition } from "../../reportSequenceDefinitionQueries";
import { ReportSequenceTraveler } from "./ReportSequenceTraveler";

const RSDDetails = () => {
  const { tsdId } = useParams<any>();
  const history = useHistory();

  const {
    openModal: isOpenModal,
    setOpenModal,
    handleModalAction,
  } = useLSDBModalState();
  const [selectedProcedureDefinitions, setSelectedProcedureDefinitions] =
    React.useState<ReportExecutionOrder[]>([]);
  const [tsdHexColor, setTsdHexColor] = React.useState("#000000");

  const { mutateAsync: updateRSD } = useUpdateReportSequence();
  const { mutateAsync: AddReportDefinitionsToTestSequence } = useAddReportDefinitionsToTestSequence();
  const { mutateAsync: removeProceduresFromTestSequence } = useRemoveReportDefinitionsFromTestSequence();

  const {
    data: testSequence  ,
    error: testSequenceError,
    isError: isErrorTestSequence,
    isLoading: isLoadingTestSequence,
  } = useReportSequenceDefinition(tsdId);


  
  // React.useEffect(() => {
  //   if (testSequence && typeof testSequence === "object"&& Object.keys(testSequence).length > 0) {
  //     const reportExecutionOrder: ReportExecutionOrder = {
  //       execution_group_name: testSequence.execution_group_name || "",
  //       report_definition_id: testSequence.report_definition_id || "" ,
  //       execution_group_number: testSequence.execution_group_number || 0 ,
  //       product_definition_id: testSequence.product_definition_id || "",
  //       // report_sequence_definition_id: testSequence.report_sequence_definition_id || "" ,
  //       // procedure_definition_name: testSequence.procedure_definition_name || "" ,
  //     };
  
  //     setTsdHexColor(testSequence.hex_color );
  //     setSelectedProcedureDefinitions([reportExecutionOrder]); 
  //   }
  // }, [testSequence]);


    React.useEffect(() => {
          if (
            testSequence &&
            testSequence.report_execution_orders &&
            testSequence.report_execution_orders.length !== 0
          ) {
            const procedureDefinitions: ReportExecutionOrder[] =
              testSequence.report_execution_orders.map((procedureDefinition: any) => {
                const procedureExecutionOrder: ReportExecutionOrder = {
                  execution_group_name: procedureDefinition.execution_group_name,
                  report_definition_id: procedureDefinition.report_definition_id,
                  execution_group_number: procedureDefinition.execution_group_number,
                  product_definition_id: procedureDefinition.product_definition_id,
                  procedure_definition_name: procedureDefinition.report_definition_name,
                  test_definition_id: procedureDefinition.test_definition_id,
                  data_ready_status : procedureDefinition.data_ready_status
                }
      
                return procedureExecutionOrder;
              });
      
            setTsdHexColor(testSequence.hex_color);
            setSelectedProcedureDefinitions(procedureDefinitions);
          }
        }, [testSequence]);

  const handleColorChange = (color: string) => {
    setTsdHexColor(color);
  };

  const addProcedureDefinitionToSelected = async (
    procedureDefinition: ReportExecutionOrder
  ) => {
    try {
      await AddReportDefinitionsToTestSequence({
        reportSequenceId: tsdId,
        reportDefinitions: [procedureDefinition],
      });

      setSelectedProcedureDefinitions((prevState) =>
        addProcedureDefinitionToList(prevState, procedureDefinition)
      );

      toast.success("Added Report Definition to Report Sequence");
    } catch (e) {
      toast.error("Error adding Report Definition to Report Sequence");
    }
  };

  const removeProcedureDefinitionFromSelected = async (
    procedureDefinition: ReportExecutionOrder
  ) => {
    try {
      await removeProceduresFromTestSequence({
        reportSequenceId: tsdId,
        reportDefinitions: [procedureDefinition],
      });

      await setSelectedProcedureDefinitions((prevState) =>
        removeProcedureDefinitionFromList(prevState, procedureDefinition)
      );
      toast.success("Deleted Report Definition");
    } catch (e) {
      toast.error("Error while deleting Report Definition");
    }
  };

  const editProcedureDefinitionInSelected = async (
    procedureDefinitionToEdit: ReportExecutionOrder,
    newProcedureDefinition: ReportExecutionOrder
  ) => {
    try {
      await removeProceduresFromTestSequence({
        reportSequenceId: tsdId,
        reportDefinitions: [procedureDefinitionToEdit],
      });

      await AddReportDefinitionsToTestSequence({
        reportSequenceId: tsdId,
        reportDefinitions: [newProcedureDefinition],
      });

      await setSelectedProcedureDefinitions((prevState) =>
        addProcedureDefinitionToList(
          removeProcedureDefinitionFromList(
            prevState,
            procedureDefinitionToEdit
          ),
          newProcedureDefinition
        )
      );
      toast.success("Edited report Definition");
    } catch (e) {
      toast.error("Error while editing report Definition");
    }
  };

  return (
    <React.Fragment>
      <LSDBModal
        title="Traveler"
        open={isOpenModal}
        handleAction={() => handleModalAction()}
      >
        <ReportSequenceTraveler id={tsdId} />
      </LSDBModal>

      {testSequence && (
        <Container>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={12}>
              <Typography variant="h3">
                Report Sequence Definition Details
              </Typography>
            </Grid>

            <Grid item container justifyContent="center" xs={12}>
              <Grid item>
                <Button
                  style={{
                    textAlign: "center",
                    marginTop: 16,
                    marginBottom: 16,
                  }}
                  variant="contained"
                  color="primary"
                  onClick={() => setOpenModal(true)}
                  // disabled
                  fullWidth
                  startIcon={<ReceiptIcon />}
                >
                  Traveler
                </Button>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <RSDForm
                initialValues={{
                  name: testSequence.name,
                  shortName: testSequence.short_name,
                  description: testSequence.description,
                  version: testSequence.version,
                  disposition: testSequence.disposition,
                  // group: testSequence.group,
                  // unitTypeFamily: testSequence.unit_type_family,
                }}
                submitForm={async (values) => {
                  // const { shortName, unitTypeFamily, ...pickedValues } = values;
                  

                  const updatedRSD = {
                    name: values.name,
                    short_name: values.shortName,
                    description: values.description,
                    version: values.version,
                    disposition: values.disposition,
                    hex_color: tsdHexColor,
                  };

                  try {
                    const response = await updateRSD({ tsdId, updatedRSD });
                    console.log(response);

                    toast.success("Successfully updated RSD");
                    history.push(`${tsdId}`);
                  } catch (e) {
                    toast.error("Error updating RSD");
                  }
                }}
                selectedProcedureDefinitionsIsEmpty={
                  selectedProcedureDefinitions.length === 0
                }
              >
                <LSDBColorPicker
                  chipLabel="Report Sequence Definition Color"
                  onChange={handleColorChange}
                  initialHexColor={testSequence.hex_color}
                />
                <ReportDefinitionsPicker
                  rsdProcedureDefinitions={selectedProcedureDefinitions}
                  onAddItem={async (newProcedureDefinition) => {
                    await addProcedureDefinitionToSelected(
                      newProcedureDefinition
                    );
                  }}
                  onEditItem={async (
                    oldProcedureDefinition,
                    newProcedureDefinition
                  ) => {
                    console.log(`Editing existing item in tsd ${tsdId}`);
                    console.log({
                      existingItem: oldProcedureDefinition,
                      newItem: newProcedureDefinition,
                    });
                    await editProcedureDefinitionInSelected(
                      oldProcedureDefinition,
                      newProcedureDefinition
                    );
                  }}
                  onDeleteItem={async (procedureDefinitionToDelete) => {
                    await removeProcedureDefinitionFromSelected(
                      procedureDefinitionToDelete
                    );
                  }}
                />
              </RSDForm>
            </Grid>
          </Grid>
        </Container>
      )}
    </React.Fragment>
  );
};

export default RSDDetails;
